/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TrackItMeasurementInfoDto } from './TrackItMeasurementInfoDto';
import {
    instanceOfTrackItMeasurementInfoDto,
    TrackItMeasurementInfoDtoFromJSON,
    TrackItMeasurementInfoDtoFromJSONTyped,
    TrackItMeasurementInfoDtoToJSON,
} from './TrackItMeasurementInfoDto';

/**
 * @type TrackItTaskWorkResultDtoTrackItMeasurement
 * 
 * @export
 */
export type TrackItTaskWorkResultDtoTrackItMeasurement = TrackItMeasurementInfoDto;


export function TrackItTaskWorkResultDtoTrackItMeasurementFromJSON(json: any): TrackItTaskWorkResultDtoTrackItMeasurement {
    return TrackItTaskWorkResultDtoTrackItMeasurementFromJSONTyped(json, false);
}

export function TrackItTaskWorkResultDtoTrackItMeasurementFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItTaskWorkResultDtoTrackItMeasurement {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...TrackItMeasurementInfoDtoFromJSONTyped(json, true) };
    return  TrackItMeasurementInfoDtoFromJSONTyped(json, true);
}

export function TrackItTaskWorkResultDtoTrackItMeasurementToJSON(value?: TrackItTaskWorkResultDtoTrackItMeasurement | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfTrackItMeasurementInfoDto(value)) {
        return TrackItMeasurementInfoDtoToJSON(value as TrackItMeasurementInfoDto);
    }

    return {};
}

/**
 * Check if a given object implements the TrackItTaskWorkResultDtoTrackItMeasurement interface.
 */
export function instanceOfTrackItTaskWorkResultDtoTrackItMeasurement(value: any): value is TrackItTaskWorkResultDtoTrackItMeasurement {
    if (instanceOfTrackItMeasurementInfoDto(value)) return true;
    return false;
}

